import { FC } from 'react'

import { Avatar } from '@mui/material'
import { PRIMARY_TRANSPARENT_GREEN } from 'utils/customizedTheme'

interface IProps {
  avatar?: string
  name?: string
  size?: string
}

export const StudentAvatar: FC<IProps> = ({ avatar=null, name=null, size='small' }) => {

  return (
    <div style={{ display: 'flex', gap: '10px' }}>
      {avatar && <div>
          <Avatar
            sx={{
              bgcolor: PRIMARY_TRANSPARENT_GREEN,
              width: size ==='small' ? 40 : 80,
              height: size ==='small' ? 40 : 80,   
            }}
            variant='circular'
            src={avatar}
          />
        </div>}
      {name && <div>{name}</div>}
    </div>
   
  )
}
